import React from 'react'
import PropTypes from 'prop-types'
import {Box, Flex, Stack, Text} from '@chakra-ui/react'
import StyledContent from '../../../leap/components/styled-content'
import ProductSpecialOffers from '../../../components/special-offer/product-special-offers'
import {HistoryIcon} from '../../../components/icons'
import useProductCertificates from '../hooks/use-product-certificates'
import Certificates from './certificates'
import {FormattedMessage} from 'react-intl'
import ExpandableText from '../../../components/expandable-text'

function CockpitInformation({
    product,
    isPromotionsLoading,
    productSpecialOffers,
    highlightsExpanded = false
}) {
    const certificates = useProductCertificates(product)

    let highlights
    if (highlightsExpanded) {
        highlights = (
            <ExpandableText as="div" maxLines={2}>
                <Text as="h2" textStyle="Semi Bold Small">
                    {product?.c_slogan}
                </Text>
                <StyledContent
                    content={product?.c_USP}
                    // apply margin here as expandable text changes display type, and we can't use flex gap
                    marginBlockStart={product?.c_slogan ? 2 : 0}
                />
            </ExpandableText>
        )
    } else {
        highlights = (
            <Stack spacing={6}>
                <Text as={'h2'} textStyle="Semi Bold Small">
                    {product?.c_slogan}
                </Text>
                <StyledContent content={product?.c_USP} />
            </Stack>
        )
    }

    return (
        <>
            {highlights}

            {product?.c_previousModelLink && (
                <Flex gap={4} alignItems="center">
                    <HistoryIcon />
                    <StyledContent content={product.c_previousModelLink} />
                </Flex>
            )}

            {/* Special offer on desktop */}
            <Box display={{base: 'none', lg: 'block'}} marginBottom={6} marginTop={2}>
                {!isPromotionsLoading && <ProductSpecialOffers {...productSpecialOffers} />}
            </Box>
            {certificates?.length > 0 && (
                <Stack>
                    <Text as={'h2'} textStyle="Semi Bold Small" paddingBottom={2}>
                        <FormattedMessage
                            id="product_view.header.awards_and_certificates"
                            defaultMessage="Warranty & Certificates"
                        />
                    </Text>
                    <Certificates certificates={certificates} />
                </Stack>
            )}
        </>
    )
}

CockpitInformation.propTypes = {
    product: PropTypes.object,
    productSpecialOffers: PropTypes.object,
    isPromotionsLoading: PropTypes.bool,
    highlightsExpanded: PropTypes.bool
}

export default CockpitInformation
